import { SvgIconProps } from '@mui/material';

const NewArrowRight = ({ width = '122', height = '37', className }: SvgIconProps) => (
  <svg width={width} height={height} viewBox="0 0 37 122" fill="none" className={className}>
    <path
      d="M1.10505 116.241C-0.369046 115.504 -0.369044 113.4 1.10505 112.663L10.6329 107.899C11.9627 107.235 13.5273 108.202 13.5273 109.688L13.5273 119.216C13.5273 120.703 11.9627 121.67 10.6329 121.005L1.10505 116.241Z"
      fill="#E8E6DF"
    />
    <path
      d="M34.877 2V98.217C34.877 107.054 27.7136 114.217 18.877 114.217H11.5273"
      stroke="#E8E6DF"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default NewArrowRight;
